<template>
  <div>
    <div class="consult-container">
      <consult-backend-errors store-namespace="springReview"></consult-backend-errors>

      <div class="consult-loader" :class="{ loadingapi: isLoadingApi }">
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h1>
            Dairy Post-Spring Review {{ seasonStartYear }} <span v-if='currentClientName'>- {{currentClientName}}</span>
          </h1>
        </div>
        <div>
          <h4>
            <nav aria-label="Page navigation">
              <ul class="pagination">
                <li>
                  <a v-on:click="resetAndsetPreviousSection" :class="{ disabled: isPreviousSectionDisabled }">
                    <span class="glyphicon glyphicon-chevron-left"></span>
                    {{previousStepName}}
                  </a>
                </li>
                <li>
                  <a href="#">
                    Step {{ currentStep }} of {{ totalSteps }}
                  </a>
                </li>
                <li>
                  <a v-on:click="resetAndsetNextSection" :class="{ disabled: isNextSectionDisabled }">
                    {{nextStepName}}
                    <span class="glyphicon glyphicon-chevron-right"></span>
                  </a>
                </li>
              </ul>
              <div class="alert alert-warning" v-if='isReadOnly'>
                This consult has been completed and cannot be edited.
              </div>
            </nav>
          </h4>
        </div>
      </div>

      <form class="clearfix">
        <component ref="currentComponentInstance"
                   :is="currentComponent"
                   store-namespace="springReview"
                   :key="currentComponent"
                   @block-next-section='blockNextSection'
                   @block-previous-section='blockPreviousSection'
                   :currentStep="currentStep"
                   :totalSteps="totalSteps">
        </component>
      </form>
      <nav aria-label="Page navigation">
          <ul class="pagination">
              <li>
                  <a v-on:click="resetAndsetPreviousSection" :class="{ disabled: isPreviousSectionDisabled }">
                      <span class="glyphicon glyphicon-chevron-left"></span>
                      {{previousStepName}}
                  </a>
              </li>
              <li>
                  <a href="#">
                      Step {{ currentStep }} of {{ totalSteps }}
                  </a>
              </li>
              <li>
                  <a v-on:click="resetAndsetNextSection" :class="{ disabled: isNextSectionDisabled }">
                      {{nextStepName}}
                      <span class="glyphicon glyphicon-chevron-right"></span>
                  </a>
              </li>
          </ul>
          <div class="alert alert-warning" v-if='isReadOnly'>
              This consult has been completed and cannot be edited.
          </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { springReviewComponents } from '../../components/spring_consult'
import { scrollToTop } from '../../_helpers/utils'
import ConsultBackendErrors from '@/components/ConsultBackendErrors'


export default {
  components: {
    ...springReviewComponents,
    ConsultBackendErrors,
  },
  data () {
    return {
      isLoadingApi: false,
      nextSectionBlocked: false,
      previousSectionBlocked: false,
    }
  },
  mounted() {

    this.onReadOnlyConsultSelected({
      clientId: parseInt(this.$route.params.client_id),
      season: parseInt(this.$route.params.season),
    })
    //   if (this.$route.params.history) {
    //       // fetch without idb
    //       this.onReadOnlyConsultSelected({
    //           clientId: parseInt(this.$route.params.client_id),
    //           season: parseInt(this.$route.params.season),
    //       })
    //   } else if (this.$route.params.client_id){
    //   this.onClientSelected({id: parseInt(this.$route.params.client_id)})
    // }
  },
  methods: {
    ...mapActions('springReview', [
      'setClient',
      'getConsultData',
      'setNextSection',
      'setPreviousSection',
      'getReadOnlyData',
    ]),
    resetAndsetNextSection() {
      this.$refs.currentComponentInstance.onSubmit()
        .then(() => {
          this.setNextSection()
          scrollToTop()
        })
    },
    resetAndsetPreviousSection() {
      this.$refs.currentComponentInstance.onSubmit()
        .then(() => {
          this.setPreviousSection()
          scrollToTop()
        })
    },

    onReadOnlyConsultSelected(consultParams) {
      this.isLoadingApi = true

      this.getReadOnlyData(consultParams).then(
        () => {},
        (error) => {
          if (error.response.status == 500) {
            this.$store.dispatch('alert/error', {message: 'An error occurred. Contact the administrator.'});
          }
        }
      ).finally(
        () => { this.isLoadingApi = false }
      )
    },
    onClientSelected(client) {
      this.setClient(client.id).then(() => {
        this.isLoadingApi = true
        let consultParams = {
          clientId: this.$route.params.client_id,
          season: this.$route.params.season,
        }
        this.getConsultData(consultParams).then(
          () => {},
          (error) => {
            if (error.response.status == 500) {
              this.$store.dispatch('alert/error', {message: 'An error occurred. Contact the administrator.'});
              return this.$router.push('/')
            }
            if (error.response.status == 400) {

              if ( error.response.data['no_active_farms'] ) {
                this.$store.dispatch('alert/error', {
                  message: 'The dairy consult could not be created because this client does not have a valid dairy shed herd registered in KVC.  Please contact farm services to resolve this issue.',
                  persist: true
                });
                return this.$router.push('/')
              } else {
                this.$store.dispatch('alert/error', {message: error.response.data.msg});
              }
            }
          }
        ).finally(
          () => { this.isLoadingApi = false }
        )
      });
    },
    blockNextSection(block) {
      this.nextSectionBlocked = block
    },
    blockPreviousSection(block) {
      this.previousSectionBlocked = block
    },
  },
  computed: {
    ...mapGetters('springReview', [
      'currentStep',
      'totalSteps',
      'currentComponent',
      'currentClientName',
      'seasonStartYear',
      'previousStepName',
      'nextStepName',
      'getStepName',
      'isReadOnly',
    ]),
    isNextSectionDisabled: function() {
      return (this.currentStep == this.totalSteps || this.nextSectionBlocked)
    },
    isPreviousSectionDisabled: function() {
      return (this.currentStep == 1 || this.previousSectionBlocked)
    },
  },
};
</script>

<style>
.farm-fields-xl {
  width: 500px;
}
.consult-container { position: relative }

.consult-container .consult-loader {
  display: none;
}

.consult-container .consult-loader.loadingapi {
  display: block;
  background: whitesmoke;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index:99999999;
  background: no-repeat center url(data:image/gif;base64,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) rgba(255, 255, 255, .7);
}

div.step-section {
  margin: 50px 5px;
}

h2.step-name {
  color: #337ab7;
  text-decoration: underline;
}
.colored-table-row {
  background-color: rgb(214, 234, 248);
}
</style>
